import {
    MEMBER_REDEEM_ROUTER,
    MEMBER_REDEEM_HISTORY_ROUTER,
    MEMBER_REDEEM_PRODUCT_SELECT_ROUTER,
    MEMBER_REDEEM_CONFIRM_ROUTER,
    MEMBER_REDEEM_PRODUCT_GUIDE_ROUTER,
} from '@Router/routerPath';
import {
    RedeemPage,
    RedeemHistoryPage,
    RedeemProductSelectPage,
    RedeemConfirmPage,
    RedeemProductGuidePage,
} from '@Local/Redeem';

const RedeemRouter = [
    {
        description: '兌換點數贈品',
        static: true,
        exact: true,
        path: MEMBER_REDEEM_ROUTER,
        href: MEMBER_REDEEM_ROUTER,
        as: RedeemPage,
    },
    {
        description: '點數歷史紀錄',
        static: true,
        path: MEMBER_REDEEM_HISTORY_ROUTER,
        href: MEMBER_REDEEM_HISTORY_ROUTER,
        as: RedeemHistoryPage,
    },
    {
        description: '兌換點數贈品－選擇商品',
        static: true,
        exact: true,
        path: MEMBER_REDEEM_PRODUCT_SELECT_ROUTER,
        href: MEMBER_REDEEM_PRODUCT_SELECT_ROUTER,
        as: RedeemProductSelectPage,
    },
    {
        description: '兌換點數贈品－確認兌換',
        static: true,
        exact: true,
        path: MEMBER_REDEEM_CONFIRM_ROUTER,
        href: MEMBER_REDEEM_CONFIRM_ROUTER,
        as: RedeemConfirmPage,
    },
    {
        description: '兌換點數贈品－贈品說明',
        static: true,
        exact: true,
        path: MEMBER_REDEEM_PRODUCT_GUIDE_ROUTER,
        href: MEMBER_REDEEM_PRODUCT_GUIDE_ROUTER,
        as: RedeemProductGuidePage,
    },
];

export default RedeemRouter;
